<template>
  <div class="animated fadeIn col-md-12">
    <b-row>
      <b-col cols="12">
        <b-card>
          <div class="text-center" v-show="isLoading">
            <b-spinner variant="primary" label="Text Centered"></b-spinner>
          </div>
          <div slot="header">
            ثبت
            <strong v-text="$lang.person"></strong>
          </div>

          <b-alert variant="danger" show dismissible v-show="errors.length">
            <li v-bind:key="index" v-for="(error, index) in errors">
              {{ error }}
            </li>
          </b-alert>

          <b-form @submit.prevent="save" v-show="!isLoading">
            <b-row>
              <b-col cols="12" md="12">
                <b-form-group
                  :label="$lang.company"
                  label-for="company_id"
                  :label-cols="$config.form.labelCol"
                >
                  <requiredComponent
                    slot="label"
                    :label="$lang.company"
                    :rules="$v.company_id.$params"
                  />

                  <selectAsync
                    :options="company_options"
                    v-model="$v.company_id.$model"
                    label="name"
                    :asyncFind="getCompanies"
                    :isValid="
                      $v.company_id.$dirty ? !$v.company_id.$error : null
                    "
                    :loading="companyLoading"
                  />

                  <b-form-invalid-feedback id="company_id-feedback"
                    >{{ $lang.error_required | replace($lang.company) }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6">
                <b-form-group
                  :label="$lang.name + `<span class='text-danger'> *</span> `"
                  label-for="name"
                  :label-cols="$config.form.labelCol"
                >
                  <requiredComponent
                    slot="label"
                    :label="$lang.name"
                    :rules="$v.name.$params"
                  />
                  <b-form-input
                    id="name"
                    type="text"
                    :autocomplete="$lang.name"
                    v-model="$v.name.$model"
                    :state="$v.name.$dirty ? !$v.name.$error : null"
                  ></b-form-input>

                  <b-form-invalid-feedback
                    v-if="!$v.name.required"
                    id="name-feedback"
                  >
                    {{ $lang.error_required | replace($lang.name) }}
                  </b-form-invalid-feedback>
                  <b-form-invalid-feedback
                    v-if="$v.name.required && !$v.name.maxLengh"
                    id="name-feedback"
                  >
                    {{
                      $lang.error_max | replace($lang.name, "بین 2 تا 35")
                    }}</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6">
                <b-form-group
                  :label="$lang.family"
                  label-for="family"
                  :label-cols="$config.form.labelCol"
                >
                  <requiredComponent
                    slot="label"
                    :label="$lang.family"
                    :rules="$v.family.$params"
                  />
                  <b-form-input
                    id="family"
                    v-model="$v.family.$model"
                    :state="$v.family.$dirty ? !$v.family.$error : null"
                    type="text"
                    :autocomplete="$lang.family"
                  >
                  </b-form-input>
                  <b-form-invalid-feedback
                    v-if="!$v.family.required"
                    id="family-feedback"
                  >
                    {{
                      $lang.error_required | replace($lang.family)
                    }}</b-form-invalid-feedback
                  >
                  <b-form-invalid-feedback
                    v-if="$v.family.required && !$v.family.maxLengh"
                    id="family-feedback"
                  >
                    {{
                      $lang.error_max | replace($lang.family, "بین 3 تا 35")
                    }}</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6">
                <b-form-group
                  :label="$lang.gender"
                  label-for="gender_selected"
                  :label-cols="$config.form.labelCol"
                >
                  <requiredComponent
                    slot="label"
                    :label="$lang.gender"
                    :rules="$v.gender_selected.$params"
                  />
                  <selectFind
                    :options="gender_options"
                    v-model="$v.gender_selected.$model"
                    label="text"
                    class="multiselect-form"
                    :isValid="
                      $v.gender_selected.$dirty
                        ? !$v.gender_selected.$error
                        : null
                    "
                    :loading="genderLoading"
                  />

                  <b-form-invalid-feedback
                    :style="{
                      display: $v.gender_selected.$error ? 'block' : 'none',
                    }"
                    id="gender_selected-feedback"
                    >{{ $lang.error_required | replace($lang.gender) }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6">
                <b-form-group
                  :label="$lang.marriage"
                  label-for="marriage_selected"
                  :label-cols="$config.form.labelCol"
                  class="multiselect-form"
                >
                  <requiredComponent
                    slot="label"
                    :label="$lang.marriage"
                    :rules="$v.marriage_selected.$params"
                  />

                  <selectFind
                    :options="marriage_options"
                    v-model="$v.marriage_selected.$model"
                    label="text"
                    :isValid="
                      $v.marriage_selected.$dirty
                        ? !$v.marriage_selected.$error
                        : null
                    "
                    :loading="marriageLoading"
                  />
                  <b-form-invalid-feedback
                    :style="{
                      display: $v.marriage_selected.$error ? 'block' : 'none',
                    }"
                    v-show="
                      $v.marriage_selected.$dirty
                        ? !$v.marriage_selected.$error
                        : null
                    "
                    id="marriage_selected-feedback"
                    >{{ $lang.error_required | replace($lang.marriage) }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6">
                <b-form-group
                  :label="$lang.father_name"
                  label-for="father_name"
                  :label-cols="$config.form.labelCol"
                >
                  <requiredComponent
                    slot="label"
                    :label="$lang.father_name"
                    :rules="$v.father_name.$params"
                  />
                  <b-form-input
                    id="father_name"
                    type="text"
                    v-model="$v.father_name.$model"
                    :state="
                      $v.father_name.$dirty ? !$v.father_name.$error : null
                    "
                    :autocomplete="$lang.father_name"
                  >
                  </b-form-input>
                  <b-form-invalid-feedback id="father_name-feedback">
                    {{ $lang.error_required | replace($lang.father_name) }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6">
                <b-form-group
                  :label="$lang.birth_date"
                  label-for="birth_date"
                  :label-cols="$config.form.labelCol"
                >
                  <requiredComponent
                    slot="label"
                    :label="$lang.birth_date"
                    :rules="$v.birth_date.$params"
                  />
                  <date-picker
                    v-model="$v.birth_date.$model"
                    :state="$v.birth_date.$dirty ? !$v.birth_date.$error : null"
                    format="YYYY/MM/DD"
                    display-format="jYYYY/jMM/jDD"
                    min="1950/01/02"
                    :max="new Date() | moment('YYYY/MM/DD')"
                    inputReq="true"
                    clearable
                    :class="
                      $v.birth_date.$dirty
                        ? $v.birth_date.$error
                          ? 'invalid-date'
                          : 'valid-date'
                        : null
                    "
                  >
                  </date-picker>
                  <b-form-invalid-feedback
                    :style="{
                      display: $v.birth_date.$error ? 'block' : 'none',
                    }"
                    id="gender_selected-feedback"
                    >{{ $lang.error_required | replace($lang.birth_date) }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6">
                <b-form-group
                  :label="$lang.person_internal_code"
                  label-for="name"
                  :label-cols="$config.form.labelCol"
                >
                  <requiredComponent
                    slot="label"
                    :label="$lang.person_internal_code"
                    :rules="$v.person_internal_code.$params"
                  />
                  <b-form-input
                    id="name"
                    type="text"
                    :autocomplete="$lang.person_internal_code"
                    v-model="$v.person_internal_code.$model"
                    :state="
                      $v.person_internal_code.$dirty
                        ? !$v.person_internal_code.$error
                        : null
                    "
                  ></b-form-input>
                  <b-form-invalid-feedback
                    v-if="!$v.person_internal_code.maxLength"
                    id="person_internal_code-feedback"
                  >
                    {{
                      $lang.error_max
                        | replace($lang.person_internal_code, "20 حداکثر")
                    }}</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6">
                <b-form-group
                  :label="$lang.national_code"
                  label-for="national_code"
                  :label-cols="$config.form.labelCol"
                >
                  <requiredComponent
                    slot="label"
                    :label="$lang.national_code"
                    :rules="$v.national_code.$params"
                  />
                  <b-form-input
                    id="national_code"
                    v-model="$v.national_code.$model"
                    :state="
                      $v.national_code.$dirty ? !$v.national_code.$error : null
                    "
                    type="text"
                    :autocomplete="$lang.national_code"
                  ></b-form-input>

                  <div
                    class="invalid-feedback"
                    v-if="!$v.national_code.numeric"
                  >
                    {{ $lang.error_numeric | replace($lang.national_code) }}
                  </div>
                  <div
                    class="invalid-feedback"
                    v-if="
                      $v.national_code.numeric &&
                      !$v.national_code.minLength | !$v.national_code.maxLength
                    "
                  >
                    {{ $lang.error_max | replace($lang.national_code, 10) }}
                  </div>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="12">
                <!-- <b-form-group :label="$lang.years_management" label-for="years_management"
                  :label-cols="$config.form.labelCol">
                  <requiredComponent slot="label" :label="$lang.years_management"
                    :rules="$v.years_management.$params" />
                  <b-form-input id="years_management" type="number" min="0" max="30"
                    v-model="$v.years_management.$model"
                    :state="$v.years_management.$dirty ? !$v.years_management.$error : null"
                    :autocomplete="$lang.years_management">
                  </b-form-input>
                  <b-form-invalid-feedback id="years_management-feedback">
                    {{$lang.error_required | replace($lang.years_management)}}
                  </b-form-invalid-feedback>
                </b-form-group> -->

                <!-- <b-form-group :label="$lang.years_management" label-for="years_management_id"
                  :label-cols="$config.form.labelCol" class="multiselect-form">
                  <requiredComponent slot="label" :label="$lang.years_management"
                    :rules="$v.years_management_selected.$params" />
                  <selectFind :options="years_management_options" v-model="$v.years_management_selected.$model"
                    label="text"
                    :isValid="$v.years_management_selected.$dirty ? !$v.years_management_selected.$error : null"
                    :loading="years_management_Loading" />
                  <b-form-invalid-feedback :style="{display:$v.years_management_selected.$error?'block':'none'}"
                    v-show="$v.years_management_selected.$dirty ? !$v.years_management_selected.$error : null"
                    id="years_management_id-feedback">
                    {{$lang.error_required | replace($lang.years_management)}}</b-form-invalid-feedback>
                </b-form-group> -->
              </b-col>
            </b-row>
            <div slot="footer" class="form-group form-btn">
              <b-button type="submit" size="md" variant="success">
                <i class="fa fa-check"></i>
                {{ $lang.submitButton }}
              </b-button>
              <b-button
                @click="handleBack"
                class="ml-2"
                size="md"
                variant="danger"
              >
                <i class="fa fa-ban"></i>
                {{ $lang.cancelButton }}
              </b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { renderEumOptions } from "@/shared/utils";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import {
  required,
  minLength,
  maxLength,
  numeric,
} from "vuelidate/lib/validators";

export default {
  name: "add-person-new",
  components: {
    datePicker: VuePersianDatetimePicker,
  },
  validations: {
    name: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(30),
    },
    family: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(35),
    },
    person_internal_code: {
      maxLength: maxLength(20),
    },
    national_code: {
      minLength: minLength(10),
      maxLength: maxLength(10),
      numeric,
    },
    birth_date: {},
    father_name: {},
    gender_selected: {
      required,
    },
    marriage_selected: {
      required,
    },
    company_selected: {},
    img: {},
    years_management_selected: {},
    company_id: {
      required,
    },
  },
  props: {
    isModal: {
      type: Boolean,
      default: false,
    },
    backUrl: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isLoading: false,
      family: null,
      name: null,
      company_id: null,
      father_name: null,
      national_code: null,
      birth_date: null,
      company_options: [],
      gender_selected: null,
      marriage_selected: null,
      company_selected: null,
      img: null,
      errors: [],
      genderLoading: false,
      marriageLoading: false,
      companyLoading: false,
      preview_image: "",
      person_internal_code: "",
    };
  },
  computed: {
    personalImage() {
      let arr = this.preview_image.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], this.img.name, {
        type: mime,
      });
    },
    gender_options() {
      return renderEumOptions("gender");
    },
    marriage_options() {
      return renderEumOptions("marriage");
    },
  },
  methods: {
    renderEumOptions,
    handleBack() {
      if (this.backUrl) {
        this.$route.push(this.backUrl);
      } else if (this.isModal) {
        this.$emit("modal-end-up");
        // this.handleBack();
      } else {
        window.history.length > 1
          ? this.$router.go(-1)
          : this.$router.push("/");
      }
    },
    clear() {
      (this.name = null),
        (this.family = null),
        (this.birth_date = ""),
        (this.national_code = null),
        (this.father_name = null),
        (this.gender_selected = null),
        (this.marriage_selected = null),
        (this.company_selected = null);
    },
    getCompanies(query) {
      if (!query || query.length < 3) {
        this.company_options = [];
        return;
      }

      this.$httpService
        .get(
          this.$config.api_url +
            this.$config.resources.company +
            "?name=" +
            query
        )
        .then((response) => {
          let company;
          company = response.data.data.result;
          this.company_options = company;
        })
        .catch((err) => {
          this.company_options = [];
        });
    },
    afterSave() {
      if (this.backUrl) {
        this.$route.push(this.backUrl);
      } else {
        this.handleBack();
      }
    },
    postData() {
      this.errors = [];
      let payload = {
        name: this.name,
        family: this.family,
        father_name: this.father_name,
        internal_code: this.person_internal_code,
        national_code: this.national_code,
        birth_date: this.birth_date,
        company_code: this.company_id.code,
        gender_id: this.gender_selected.value,
        // years_management: this.years_management_selected && this.years_management_selected.value
      };
      if (this.marriage_selected && "value" in this.marriage_selected) {
        payload.marriage_id = this.marriage_selected.value;
      }
      this.$httpService
        .post(this.$config.api_url + this.$config.resources.person, payload)
        .then((response) => {
          this.$notify.success(response.data.message);
          this.afterSave();
          this.$emit("getItems");
        })
        .catch((err) => {
          if (
            err.response &&
            "status" in err.response &&
            err.response.status == 400
          ) {
            if (typeof err.response.data.message === "object") {
              err.response.data.message.forEach((element) => {
                this.errors.push(element);
              });
            } else {
              this.$notify.error(err.response.data.message);
            }
          } else {
            this.$notify.error(err.message);
          }

          this.isLoading = false;
        });
    },
    save() {
      this.$v.$touch();
      if (this.$v.$anyError) {
        return;
      }

      this.isLoading = true;
      this.postData();
    },
  },
};
</script>

